/**
 * Tutorial content per page.
 * Spotlight step: { text, highlight?, heading? } — highlight = data-tutorial value.
 * Intro step (dashboard only): { kind: 'intro', eyebrow?, title, blocks: [{ icon, title, text }] }
 *   icon: 'Flag' | 'QrCode' | 'Camera' (lucide names mapped in TutorialModal).
 */
export const TUTORIAL_CONTENT = {
  dashboard: {
    title: 'Scorecard tips',
    steps: [
      {
        kind: 'intro',
        eyebrow: "Welcome to Puttzin'",
        title: "Here's how it works",
        blocks: [
          {
            icon: 'Flag',
            title: 'Score each hole',
            text: 'Tap a player, pick their score (1–6). Every hole, every player. We track totals for you.',
          },
          {
            icon: 'QrCode',
            title: 'Confirm at the venue',
            text: "When you finish a hole, scan the host's Puttzin QR to lock in your scores. No scan, no submit.",
          },
          {
            icon: 'Camera',
            title: 'Vote and win',
            text: 'Upload your team costume and vote on the best ones. Raffle tickets are on-site at any venue.',
          },
        ],
      },
      {
        heading: 'Up next',
        text: 'This card shows which hole to play. Tap Enter scores to open scoring for that stop.',
        highlight: 'dashboard-up-next',
      },
      {
        heading: 'Team total',
        text: 'Your team score and progress update as you play.',
        highlight: 'score-hero',
      },
      {
        heading: 'Scorecard',
        text: 'Any hole on the list opens scoring for that venue when you are ready.',
        highlight: 'hole-cards',
      },
      {
        heading: 'Menu',
        text: 'Jump to Leaderboard, Vote, or Raffle any time from the top menu.',
        highlight: 'main-nav',
        footerHint: true,
      },
    ],
  },
  play: {
    title: 'Scoring a Hole',
    steps: [
      { text: 'Tap a player, then pick their score (1–6). The next player opens automatically.', highlight: 'score-stack' },
      {
        text: "Mulligan (-1): every hole sponsor runs their own challenge or promotion. Complete it with the host to get that hole's mulligan code, then check the -1 box for that player before you submit.",
        highlight: 'score-stack',
      },
      { text: 'Scan the venue QR from the host to confirm your scores, then Submit.', highlight: 'score-stack' },
    ],
  },
  leaderboard: {
    title: 'Live Rankings',
    steps: [
      { text: 'Rankings update live as teams submit scores.', highlight: 'leaderboard-podium' },
      { text: 'Tap a team card to see their hole-by-hole breakdown.', highlight: 'leaderboard-rankings' },
    ],
  },
  voting: {
    title: 'Cast Your Votes',
    steps: [
      {
        text: "Score every team on a 1-3 scale. 1 = meh, 3 = best. All scores combine across teams to pick the winner.",
        highlight: 'voting-booth',
      },
      {
        text: 'Tap 1, 2, or 3 on each card to lock in your rating. Colors match the score value.',
        highlight: 'voting-rank-buttons',
      },
      {
        text: 'Track progress here. You can go back or switch to grid review to change any rating.',
        highlight: 'voting-progress',
      },
      {
        text: 'Best Hole uses the exact same rating flow. Upload your team costume separately.',
        highlight: 'voting-tab-hole',
      },
    ],
  },
  raffle: {
    title: 'Raffle Prizes',
    steps: [
      { text: 'Browse the prizes up for grabs at the Final Encore Party.', highlight: 'raffle-prizes' },
      { text: 'Get raffle tickets on-site at any venue — winners drawn at the party.', highlight: null },
    ],
  },
}

export const DEFAULT_TUTORIAL_CONTENT = {
  title: 'Quick Tip',
  steps: [{ text: 'Explore this page for actions and event details.', highlight: null }],
}
